export default [
  {
    code: 470,
    message: 'Message failed to send because more than 24 hours have passed since the customer last replied to this number',
  },
  {
    code: 1014,
    message: 'Request failed',
  },
  {
    code: 1000,
    message: 'Video file has unsupported format',
  },
  {
    code: 501,
    message: 'Message type is not currently supported',
  },
];
